const SuccessStep = () => {
  return (
    <div className="text-center py-4 px-2">
      <div className="mb-4">
        <div
          className="d-inline-flex align-items-center justify-content-center rounded-circle"
          style={{
            width: "160px",
            height: "160px",
            border: "8px solid #00D34D",
          }}
        >
          <i
            className="fas fa-check"
            style={{
              fontSize: "80px",
              color: "#00D34D",
            }}
          ></i>
        </div>
      </div>

      <h2 className="fw-bold text-black mb-3">Success!</h2>

      <p className="text-muted fs-16 mb-4 px-3" style={{ lineHeight: "1.5" }}>
        Your main balance will be updated shortly after review.
      </p>

      <p className="text-muted fs-14 mb-0 px-2" style={{ lineHeight: "1.6" }}>
        Please allow up to 2 hours during business hours for the amount to be
        reflected in your main balance. Until then, the amount will be shown as
        "pending".
      </p>
    </div>
  );
};

export default SuccessStep;
